import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import DocumentIcon from '@mui/icons-material/DescriptionOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { dateObjToLocalZone, trimString } from '../../../utils/converter';
import { useContext } from 'react';
import { appContext } from '../../../AppContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import EditFileLabel from './EditFileLabel';
import ValidationResult from './ValidationResult';
import { addNotValidated } from '../../../utils/history/addNotValidated';
import { hashExistInFiles } from '../../../utils/fileHelpers';

const TableRows = ({ data, getHistory, handleDelete }) => {
  const { files, setFiles, validationComplete, validateState, setValidationComplete } =
    useContext(appContext);

  const location = useLocation();
  const navigate = useNavigate();

  // Function to add an uploaded file to the DragNDrop box.
  const handleNotValidated = async (hash) => {
    await addNotValidated(hash, setFiles, validationComplete, validateState, setValidationComplete);
    if (location.pathname !== '/') {
      navigate('/');
    }
  };

  return (
    <tbody className="text-[14px] font-normal">
      {data &&
        data.map((item, i) => (
          <tr key={i} className="bg-core-black-contrast h-[66px]">
            <td className="p-4 align-middle">
              <p>{trimString(item.FILE_NAME)}</p>
            </td>
            <td className="p-4 align-middle">
              <EditFileLabel
                historyItem={item}
                indexOfHistoryItem={i}
                getHistory={getHistory}
                data={data}
              />
            </td>
            {/* <td className="p-4 align-middle">{item.FILE_SIZE} Bytes</td> */}
            <td className="p-4 align-middle">
              {item.VALIDATION_DATE && (
                <>
                  <p>{dateObjToLocalZone(item.VALIDATION_DATE).split(' ')[0]}</p>
                  <p className="text-core-grey-60">
                    {dateObjToLocalZone(item.VALIDATION_DATE).split(' ')[1]}
                  </p>
                </>
              )}
              {+item.VALID === 2 &&
                (hashExistInFiles(files, item.HASH) ? (
                  <p>Pending </p>
                ) : (
                  <p>
                    <a
                      onClick={() => handleNotValidated(item.HASH)}
                      className="text-blue-400 cursor-pointer"
                    >
                      Validate
                    </a>
                  </p>
                ))}
            </td>
            <td className="p-4 align-middle">
              <ValidationResult historyItem={item} />
            </td>
            <td className="p-4 cursor-pointer align-middle">
              <Link
                to={`/details/${item.ID}`}
                className="h-8 w-[80px] px-4 py-3 justify-center items-center gap-2 inline-flex bg-minima-orange-2023 text-black font-medium
               hover:bg-minima-orange-light transition-all duration-300 ease-in-out"
              >
                Details
              </Link>
            </td>
            <td className="p-4 align-middle">
              {item.TOKEN_ID ? (
                <Link to={`/pdf/${item.ID}`}>
                  <DocumentIcon className="cursor-pointer hover:text-orange" />
                </Link>
              ) : (
                <button disabled className="cursor-not-allowed text-core-black-contrast-3">
                  <DocumentIcon />
                </button>
              )}
            </td>
            <td className="p-4 align-middle">
              <button
                onClick={() => handleDelete(item)}
                className="hover:text-minima-core-orange cursor-pointer"
              >
                <DeleteIcon />
              </button>
            </td>
          </tr>
        ))}
    </tbody>
  );
};
export default TableRows;
